// Error state management module
const state = {
  hasError: false,
  error: null,
  errorInfo: null,
  errorId: null,
  errorTimestamp: null
};

const mutations = {
  SET_ERROR(state, { error, errorInfo }) {
    state.hasError = true;
    state.error = error;
    state.errorInfo = errorInfo;
    state.errorId = Date.now().toString();
    state.errorTimestamp = new Date().toISOString();
  },
  
  CLEAR_ERROR(state) {
    state.hasError = false;
    state.error = null;
    state.errorInfo = null;
    state.errorId = null;
    state.errorTimestamp = null;
  },
  
  RESET_ERROR_STATE(state) {
    state.hasError = false;
    state.error = null;
    state.errorInfo = null;
    state.errorId = null;
    state.errorTimestamp = null;
  }
};

const actions = {
  captureError({ commit }, { error, errorInfo }) {
    console.error('Error captured in store:', error, errorInfo);
    
    commit('SET_ERROR', { error, errorInfo });
    
    // You can add additional error reporting logic here
    // Example: Send to monitoring service
    if (window.Sentry) {
      window.Sentry.captureException(error);
    }
  },
  
  clearError({ commit }) {
    commit('CLEAR_ERROR');
  },
  
  resetErrorState({ commit }) {
    commit('RESET_ERROR_STATE');
  }
};

const getters = {
  hasError: state => state.hasError,
  currentError: state => state.error,
  errorInfo: state => state.errorInfo,
  errorId: state => state.errorId,
  errorTimestamp: state => state.errorTimestamp,
  
  errorMessage: state => {
    if (!state.error) return '';
    
    if (typeof state.error === 'string') {
      return state.error;
    }
    
    if (state.error.message) {
      return state.error.message;
    }
    
    return 'An unexpected error occurred';
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
